import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../services/api";

function SpotifyCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("connecting");
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const errorParam = params.get("error");

    if (errorParam) {
      setError(errorParam);
      return;
    }

    if (!code) {
      setError("No authorization code received");
      return;
    }

    const redirectUri = `${window.location.origin}/auth/spotify/callback`;
    apiClient
      .post("/spotify/callback", { code, redirect_uri: redirectUri })
      .then((data) => {
        setStatus("success");
        setTimeout(() => navigate("/admin", { replace: true }), 1500);
      })
      .catch((err) => {
        setError(err.message || "Failed to connect Spotify");
      });
  }, [navigate]);

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <div style={{ fontSize: "4rem", marginBottom: "1.5rem" }}>❌</div>
        <h2 style={{ color: "var(--color-danger)", marginBottom: "1rem" }}>
          Spotify Connection Failed
        </h2>
        <p style={{ color: "var(--color-text-muted)", marginBottom: "2rem" }}>{error}</p>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/admin", { replace: true })}
        >
          Back to Settings
        </button>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <div style={{ fontSize: "4rem", marginBottom: "1.5rem" }}>🎵</div>
        <h2 style={{ color: "var(--color-text)", marginBottom: "1rem" }}>
          Spotify Connected!
        </h2>
        <p style={{ color: "var(--color-text-muted)" }}>Redirecting to settings...</p>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: "4rem" }}>
      <div style={{ fontSize: "4rem", marginBottom: "1.5rem" }}>🎵</div>
      <h2 style={{ color: "var(--color-text)", marginBottom: "1rem" }}>
        Connecting Spotify...
      </h2>
      <p style={{ color: "var(--color-text-muted)" }}>Please wait...</p>
    </div>
  );
}

export default SpotifyCallback;
